export const ACTIVITY_EVENTS = {
  SEND_ACTIVITY_NOTIFICATION: 'activity/notification.send',
} as const;

export interface SendActivityNotificationEvent {
  name: typeof ACTIVITY_EVENTS.SEND_ACTIVITY_NOTIFICATION;
  data: {
    activityId: string;
    notificationId: string;
    gymId: string;
    userId: string;
    instanceName: string;
    message: string;
    clients: Array<{
      clientId: string;
      clientName: string;
      phoneNumber: string;
      data: {
        id: string;
        name: string;
        email?: string;
        phone: string;
        activePlan?: {
          name: string;
          expirationDate?: Date;
          amount?: number;
        };
        membershipStatus?: string;
        metadata?: Record<string, any>;
      };
    }>;
    gymData: {
      name: string;
      phone?: string;
      address?: string;
      countryConfig: {
        currency: string;
        locale: string;
      };
    };
    activityData: {
      name: string;
      startDateTime: Date;
      durationMinutes: number;
      location: string;
    };
  };
}
